import React from 'react'

export default function BT(props) {
    return (
        <b className={props.class}>{props.text}</b>
    )
}